import axios, { AxiosResponse } from "axios";

// Define the shape of each field to update
interface FieldToUpdate {
  field: string;
  value: string | number[] | number | Date | null | undefined; // You could use `any` here if the value might not always be a string
}

// Generalized utility function to save any fields to the session
export const saveResultsModules = async (
  fieldsToUpdate: FieldToUpdate[], // An array of fields to update
  sessionId: string,
  role: string 
): Promise<void> => {
  try {
    // console.log("fieldsToUpdate", fieldsToUpdate);
    // console.log("sessionId", sessionId);

    // Iterate over each field-value pair and send a patch request
    for (const { field, value } of fieldsToUpdate) {
      const response: AxiosResponse = await axios.patch(
        `/${role}/session/${sessionId}/field`,
        {
          field,
          value,
        }
      );

      // Check if the response is not successful
      if (response.status !== 200) {
        console.error(`Failed to update field ${field}`, response);
        return; // Stop further execution if an error occurs
      }
    }

    // console.log("Session fields updated successfully");
  } catch (error) {
    console.error("An error occurred while saving results:", error);
  }
};
